// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".articles-upload-text{color:rgba(0,0,0,.6)}.van-uploader,.van-uploader__input-wrapper{width:100%}", ""]);
// Exports
module.exports = exports;
